import { useQueries } from '@tanstack/react-query';
import { CrmEndpoints } from '../../../constants/endpoints/crmEndpoints.ts';
import { EntityNoteModel } from '../../../globalModels/entityNotes/entityNoteModel';
import { getAxios } from '../../../lib/axios';
import { EntityNotesFilterModel } from '../types/entityNotesFilterModel';

export function useMultipleEntitiesNotesQuery(entityIds: number[], filterState: EntityNotesFilterModel) {
  return useQueries({
    queries: entityIds?.map((id) => ({
      queryKey: ['entityNotes', id, filterState],
      retry: false,
      queryFn: async () => {
        const response = await getAxios().post<Array<EntityNoteModel>>(CrmEndpoints.EntityNotes.list(id), filterState);
        return response.data;
      },
      enabled: !!id // Ensure the query runs only if `id` is defined
    }))
  });
}
